import axios from "../axios/AxiosInstance";

export function needsAtradiusReview(cover) {
  const document = cover?._doc || cover;
  const limit = document?.totalDecision?.decisionAmtInPolicyCurrency;
  const outstanding = cover?.montantNonFacture;
  if (limit === null || limit === undefined || limit === "" || outstanding === null || outstanding === undefined || outstanding === "") return false;
  return Number.isFinite(Number(limit)) && Number.isFinite(Number(outstanding)) && Number(outstanding) > Number(limit);
}

export async function loadAtradiusReviews() {
  const { data } = await axios.get("client/freelance");
  const clients = Array.isArray(data) ? data : [];
  const reviews = [];
  let cursor = 0;
  let failures = 0;
  await Promise.all(Array.from({ length: Math.min(6, clients.length) }, async () => {
    while (cursor < clients.length) {
      const client = clients[cursor++];
      try {
        const { data: response } = await axios.get(`cover/client/${client._id}`);
        const cover = Array.isArray(response) ? response[0] : response;
        if (needsAtradiusReview(cover)) reviews.push({ client, cover });
      } catch (error) { if (error.response?.status !== 404) failures++; }
    }
  }));
  return { reviews, failures, clients };
}
